import { AsyncPipe, SlicePipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  output,
  inject,
  input,
  effect,
} from '@angular/core';
import { RouterModule,Router } from '@angular/router';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClientService } from '@fitness-force/api';

@Component({
  selector: 'member-nonmember',
  templateUrl: './member-nonmember.component.html',
  styleUrls: ['./member-nonmember.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PopoverModule,
    AvatarModule,
    StyleClassModule,
    ShortNamePipe,
    RouterModule,
    AsyncPipe,
    SlicePipe,
    TitleCasePipe,
  ],
})
export class MemberNonmemberComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly clientService = inject(ClientService);

  readonly clientData = input<any>();
  columnData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>();
  colData = new BehaviorSubject(null);
  showIcon = true;
  showTransferIcon = false;

  constructor() {
    effect(() => {
      const client = this.clientData();
      if (client) {
        this.applyColumnData(client);
      }
    });
  }

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (col: any) => {
        if (col) {
          this.applyColumnData(col);
        }
      },
    });
  }

  private applyColumnData(col: any): void {
    if (col?.transfer_from_client) {
      this.colData.next(col?.transfer_from_client);
      this.showIcon = false;
      this.showTransferIcon = true;
    } else if (col?.transfer_to_client) {
      this.colData.next(col?.transfer_to_client);
      this.showIcon = false;
      this.showTransferIcon = true;
    } else if (col?.frz_req_clt_details) {
      this.colData.next(col?.frz_req_clt_details);
      this.showIcon = false;
      this.showTransferIcon = false;
    } else if (col?.client_details) {
      this.colData.next(col?.client_details);
      this.showIcon = false;
      this.showTransferIcon = false;
    } else if (col?.client) {
      this.colData.next(col?.client);
      this.showIcon = false;
      this.showTransferIcon = false;
    } else {
      this.colData.next(col);
    }
  }
  gotoClient(id: any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/client/profile/', id]),
    );
    window.open(url, '_blank');
  }

  getClientType(row: any): string {
    switch (row?.client_status) {
      case 'Client':
        return 'Member';
      default:
        return '';
    }
  }

  clientStatus(client: any): string {
    if (client?.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString(),
      );
    else return '';
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }
}
